import { useIntl } from 'react-intl';
import Translations from '../App.translations';

export const useRenderNoInfoIfValueIsNull = (value: string | number | Date) => {
  const { formatMessage } = useIntl();

  return value ?? formatMessage(Translations.AppNoInformation);
};
